import { IVeriTag } from "@directives/_veri/v-tags/v-tags.component";
import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import { BroadcastEvent } from "@enums/BroadcastEvent";
import { SortType } from "@enums/SortType";
import { IObservationFilter } from "@interfaces/filters/IObservationFilter";
import { IRunBlockRootScope } from "@interfaces/IRunBlockRootScope";
import { IObservationCategory, ObservationsService } from "@services/observations.service";
import { TranslationService } from "@services/translation.service";
import * as angular from "angular";
import { IVideoEntry } from "../../../main/components/videos/models/IVideoEntry";
import { IFilterBar, IFilterBarFilter } from "../newResourceFilterBar.component";
import "./observationsResourceFilter.scss";

class ComponentController implements angular.IComponentController, IFilterBarFilter<IObservationFilter>{
    parent: IFilterBar;
    show = false;
    isDirty = false;

    filterName = "Observation";
    filterLabel: string;
    filterTitle: string;
    filterIcon: string;
    showClearFilterButton = true;

    observations: IObservationCategory[] = [];
    eventsToFilter: IVideoEntry[];

    loading: boolean;

    selectedObservation: IVeriTag<any>;

    previousFilter: IObservationFilter;

    tableHeaders: IVeriTableHeader[];
    tableRows: IVeriTableRow<IVeriTag<any>>[];

    onChange: (args: { filter: IObservationFilter }) => void;

    static $inject = ["$rootScope", "$element", "observationsService", "translationService"];

    constructor(
        private readonly $rootScope: IRunBlockRootScope,
        public readonly $element: HTMLElement,
        private readonly observationsService: ObservationsService,
        private readonly translationService: TranslationService) {
    }

    $onInit() {
        this.parent.registerFilter(this);
        this.createTableHeaders();
    }

    $onDestroy() {
        this.show = false;
    }

    $onChanges(onChangesObj: angular.IOnChangesObject) {
        this.updateFilterLabel();
    }

    toggleFilter(show: boolean) {
        this.show = show;

        if (this.show) {
            this.getObservations();
        }
    }

    clearFilter() {
        this.selectedObservation = null;
        this.updateFilterLabel();
    }

    selectedObservationChanged(observation: IVeriTag<any>) {
        if (this.selectedObservation?.label == observation.label) {
            this.selectedObservation = null;
        }
        else {
            this.selectedObservation = observation;
        }

        this.updateFilterLabel();
        this.createFilterObject();

        this.$rootScope.$broadcast(BroadcastEvent.closeResourceFilterBar);
    }

    createFilterObject(): IObservationFilter {
        return {
            observation: this.selectedObservation
        };
    }

    // ------------------

    private createTableHeaders() {
        this.tableHeaders = [
            {
                title: this.translationService.t("filters.observationsResourceFilter.observations"),
                sortable: true
            },
            {
                title: this.translationService.t("filters.observationsResourceFilter.count"),
                sortable: true,
                sortType: SortType.Number,
                width: 60
            }
        ];
    }

    private getObservations() {
        this.loading = true;

        this.observations = [];

        this.observations = this.observationsService.getObservations(this.eventsToFilter);

        this.createTableRows();
        this.updateFilterLabel();

        this.loading = false;
    }

    private updateFilterLabel() {
        this.filterLabel = this.translationService.t("filters.observationsResourceFilter.observations");
        this.filterIcon = "style";

        if (this.selectedObservation) {
            this.filterLabel = this.selectedObservation.label;
        }

        this.isDirty = !!this.selectedObservation;
    }

    private createTableRows() {
        this.tableRows = [];

        this.observations.forEach(observation => {
            this.tableRows.push({
                data: observation,
                cells: this.createTableCells(observation),
                rowClassName: observation.count == 0 ? "disabled" : ""
            });
        });
    }

    private createTableCells(observation: IObservationCategory): IVeriTableRowCell[] {
        const obsTitle = this.translationService.t(`VideoObservationEnum.${observation.label}`);

        const cells: IVeriTableRowCell[] = [
            {
                contents: obsTitle,
                data: observation,
                sortData: obsTitle
            },
            {
                contents: observation.count.toString(),
                sortData: observation.count
            }
        ];

        return cells;
    }
}

export class ObservationsResourceFilterComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    require: { [index: string]: string; };
    template: string;

    constructor() {
        this.bindings = {
            selectedObservation: "<",
            onChange: "&",
            eventsToFilter: "<?"
        };

        this.require = {
            parent: "^newResourceFilterBar"
        };

        this.controller = ComponentController;
        this.template = require("./observationsResourceFilter.html");
    }
}
